import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-tipo-forma-pago-lista',
  templateUrl: './lista.component.html'
})

export class ListaComponent{
  tamano = document.body.clientHeight;
}